import {css} from 'styled-components';
import {media} from "../../../helpers/mixins";
import {GRAY_TEXT, PINK, PURPLE_DARK_HEADER} from "../../../constants/colors";

export default {
  cartTicketsListItem: css`
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    border-bottom: 2px #D8D8D8 solid;
  `,

  cartTicketsListItemIcon: css`
    width: 30px;
    height: 30px;
    display: flex;
    align-self: flex-start;
    justify-self: center;
    margin-top: 1rem;
    ${media.md`
      width: 60px;
      height: 60px;
      align-self: center;
      margin: 0;
    `};
  `,

  cartTicketsListItemInfoWrapper: css`
    display: flex;
    flex-direction: column;
    width: 95%;
    margin-top: 1rem;
    margin-bottom: 1rem;
    margin-right: 1rem;
    margin-left: 0.3rem;
    ${media.md`
      margin: 1rem;
      width: 60%;
    `};
  `,

  cartTicketsListItemProduct: css`
    color: ${PURPLE_DARK_HEADER};
    font-size: 15px;
    display: flex;
    ${media.md`
      font-size: inherit;
    `};
  `,

  cartTicketsListItemDelete: css`
    width: 20px;
    height: 20px;
    display: flex;
    align-self: flex-end;
    cursor: pointer;
    ${media.md`
      margin: 0;
    `};
  `,

  cartTicketsListItemInfoLabel: css`
    color: ${PINK};
    font-size: 15px;
    white-space: nowrap;
  `,

  cartTicketsListItemInfoText: css`
    color: ${GRAY_TEXT};
    font-size: 15px;
    ${media.md`
      font-size: 15px;
    `};
  `,

  cartTicketsListItemInfoRow: css`
    display: flex;
    align-items: flex-end;
  `,

  cartTicketsListItemInfoCol: css`
    display: flex;
    flex-direction: column;
    margin-right: 0.5rem;
    ${media.md`
      margin-right: 1rem;
    `}
  `,
};
